<template>
	<div class="account-container">
		<div class="wrapper">
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import layoutMixin from '@Mixin/layoutMixin';
	import headerMixin from '@Mixin/headerMixin';
	export default {
		mixins: [layoutMixin, headerMixin],
		mounted() {
			this._setHeaderTitle('Sign In');
			this._setHeaderItems([
				'empty',
				'title',
				{
					key: 'close',
					props: {},
				}
			]);
		},
		created() {
			this.setRouteLayout({
				name: 'Checkout',
				value: 'MinimalCheckout',
			});
		},
		destroyed() {},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.account-container {
		position: relative;
	}
	.wrapper {
		position: absolute;
		top: 0;
		width: 100vw;
		padding-top: $mobileNavigationHeight;
	}
</style>


// WEBPACK FOOTER //
// src/components/account/Account.vue